import moment from 'moment';

// Expiry is a stored calendar date. UTC-midnight ISO is the legacy raw-list contract.
const formatSubscriptionBusinessDate = (value) => {
  if (typeof value !== 'string') return null;
  const calendar = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? value
    : /^\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?Z$/.test(value)
    ? value.slice(0, 10)
    : null;
  if (!calendar || Number(calendar.slice(0, 4)) < 1000) return null;
  const date = moment.utc(calendar, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format('MMM DD, YYYY') : null;
};

export default formatSubscriptionBusinessDate;
